import { render, staticRenderFns } from "./ModalPersonalData.vue?vue&type=template&id=4f695fae&scoped=true&"
import script from "./ModalPersonalData.vue?vue&type=script&lang=js&"
export * from "./ModalPersonalData.vue?vue&type=script&lang=js&"
import style0 from "./ModalPersonalData.vue?vue&type=style&index=0&id=4f695fae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f695fae",
  null
  
)

export default component.exports